import { unstable_generateUtilityClass as generateUtilityClass, unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
export function getDateRangePickerToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiDateRangePickerToolbar', slot);
}
export const dateRangePickerToolbarClasses = generateUtilityClasses('MuiDateRangePickerToolbar', ['root', 'container']);